import theme from "app/Theme/Theme";
import React from "react";
import Svg, { Path } from "react-native-svg";

const LinkIcon = ({ width, height, color }) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      preserveAspectRatio="xMidYMin meet"
    >
      <Path
        d="M3.38215 7.35901L1.45323 9.28793C0.66218 10.079 0.217773 11.1519 0.217773 12.2706C0.217773 13.3893 0.66218 14.4622 1.45323 15.2532C2.24428 16.0443 3.31717 16.4887 4.43588 16.4887C5.55459 16.4887 6.62749 16.0443 7.41853 15.2532L9.98855 12.6818C10.4656 12.2047 10.8212 11.6202 11.0255 10.9772C11.2299 10.3342 11.277 9.65164 11.163 8.98669C11.049 8.32174 10.7771 7.69385 10.3702 7.15572C9.96325 6.61759 9.43318 6.18493 8.82445 5.89404L8.00059 6.71791C7.91693 6.80169 7.84419 6.89569 7.78407 6.99769C8.25439 7.13289 8.68128 7.3885 9.02254 7.73925C9.36379 8.09 9.6076 8.52373 9.72986 8.99758C9.85212 9.47143 9.8486 9.96898 9.71964 10.441C9.59069 10.9131 9.34076 11.3434 8.99457 11.6892L6.42596 14.2592C5.89834 14.7869 5.18274 15.0833 4.43658 15.0833C3.69043 15.0833 2.97483 14.7869 2.44721 14.2592C1.9196 13.7316 1.62319 13.016 1.62319 12.2699C1.62319 11.5237 1.9196 10.8081 2.44721 10.2805L3.5621 9.16702C3.4048 8.57755 3.34403 7.9665 3.38215 7.3576V7.35901Z"
        fill={color}
      />
      <Path
        d="M4.78401 7.94687L5.0188 7.71208C5.36712 7.36247 5.80172 7.11122 6.2785 6.98382C6.40591 6.50703 6.65716 6.07244 7.00677 5.72411L7.24155 5.48933C6.53433 5.44956 5.82846 5.58832 5.18891 5.89282C4.87961 6.53955 4.74464 7.24672 4.78401 7.94546V7.94687Z"
        fill={color}
      />
      <Path
        d="M6.01248 4.73003C5.53546 5.20712 5.17985 5.79168 4.97549 6.43464C4.77113 7.0776 4.724 7.76021 4.83804 8.42516C4.95207 9.09011 5.22396 9.718 5.63087 10.2561C6.03779 10.7943 6.56786 11.2269 7.17658 11.5178L8.26617 10.4268C7.78949 10.299 7.35486 10.0479 7.00595 9.69883C6.65705 9.34978 6.40616 8.91504 6.2785 8.43831C6.15084 7.96158 6.1509 7.45964 6.27869 6.98294C6.40647 6.50624 6.65747 6.07157 7.00647 5.72261L9.57508 3.15259C10.1027 2.62498 10.8183 2.32857 11.5645 2.32857C12.3106 2.32857 13.0262 2.62498 13.5538 3.15259C14.0814 3.68021 14.3778 4.39581 14.3778 5.14197C14.3778 5.88813 14.0814 6.60372 13.5538 7.13134L12.4389 8.24483C12.5964 8.83531 12.6568 9.44688 12.6189 10.0542L14.5478 8.12532C15.3389 7.33427 15.7833 6.26138 15.7833 5.14267C15.7833 4.02396 15.3389 2.95107 14.5478 2.16002C13.7568 1.36897 12.6839 0.924561 11.5652 0.924561C10.4464 0.924561 9.37355 1.36897 8.5825 2.16002L6.01248 4.73003Z"
        fill={color}
      />
      <Path
        d="M10.8124 11.5177C11.1182 10.8786 11.2575 10.1725 11.2173 9.46509L10.9825 9.69988C10.6342 10.0495 10.1996 10.3007 9.72282 10.4281C9.59542 10.9049 9.34416 11.3395 8.99455 11.6878L8.75977 11.9226C9.46699 11.9624 10.1729 11.8236 10.8124 11.5191V11.5177Z"
        fill={color}
      />
    </Svg>
  );
};

LinkIcon.defaultProps = {
  width: 16,
  height: 17,
  color: theme.colors["neutral.white"],
};

export default LinkIcon;
